import { SvgIcon } from "@mui/material";
import i18n from "../../../../../i18n";
import styles from "./PlayOverlay.module.css";
import ReplayIcon from "../../../Resources/replay.svg?react";
import ReplayIconGlowing from "../../../Resources/replay-glowing.svg?react";
import PlayOverlayIcon from "../../../Resources/play-overlay.svg?react";
import PlayOverlayIconGlowing from "../../../Resources/play-overlay-glowing.svg?react";

type PlayOverlayProps = {
	useVideoEndedOverlay: boolean;
	isOverlayVisible: boolean;
	setPlay: () => void;
};

export default function PlayOverlay({ useVideoEndedOverlay, isOverlayVisible, setPlay }: PlayOverlayProps) {
	return (
		<button
			className={styles.videoOverlay}
			style={{
				opacity: isOverlayVisible ? 1 : 0,
				backgroundColor: useVideoEndedOverlay ? "#000000F2" : "#00000059",
			}}
			onClick={(e) => {
				setPlay();
				e.stopPropagation();
			}}
			aria-label={
				useVideoEndedOverlay
					? i18n.t("result.components.studentSelection.videoPlayer.videoPlayerTSX.restartVideoLabel")
					: i18n.t("result.components.studentSelection.videoPlayer.videoPlayerTSX.playVideoLabel")
			}
		>
			<div
				className={styles.overlayButtonCircle}
				style={{ backgroundColor: useVideoEndedOverlay ? "#212121" : "#000000CC" }}
			>
				{useVideoEndedOverlay ? (
					<>
						<SvgIcon
							component={ReplayIcon}
							opacity={1}
							viewBox="0 0 130 130"
							style={{ width: "130", height: "130", color: "#F4F4F4", cursor: "pointer" }}
							className={styles.overlayIcon}
						/>
						<SvgIcon
							component={ReplayIconGlowing}
							opacity={1}
							viewBox="0 0 130 130"
							style={{ width: "130", height: "130", color: "#F4F4F4", cursor: "pointer" }}
							className={styles.glowingIcon}
						/>
					</>
				) : (
					<>
						<SvgIcon
							component={PlayOverlayIcon}
							opacity={1}
							viewBox="0 0 78 78"
							style={{ width: "78", height: "78", color: "#F4F4F4", cursor: "pointer" }}
							className={styles.overlayIcon}
						/>
						<SvgIcon
							component={PlayOverlayIconGlowing}
							opacity={1}
							viewBox="0 0 78 78"
							style={{ width: "78", height: "78", color: "#F4F4F4", cursor: "pointer" }}
							className={styles.glowingIcon}
						/>
					</>
				)}
			</div>
		</button>
	);
}
